import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { readAllTenant } from '../../../services';

import PbxContext from '../../../context/PbxContext';
import '../../../libs/bulma.min.css';

import Loading from '../../Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faEye, faPlus, faFilter, faTrash } from '@fortawesome/free-solid-svg-icons';

export default function AudioUpload() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsChangeFormElements, toggleIsHidden, setItemsSelectedToEdit } = getItensStateGlobal;
  
  let url = window.location.href;
  url = url.split('/')[2];

  const [file, setFile] = useState(null);
  const [name, setName] = useState("");
  const [nameFile, setNameFile] = useState(null);
  const [type, setType] = useState("");
  const [tenant, setTenant] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [tenantsDb, setTenantsDb] = useState([]);

  const getDataInitialPage = async () => {
    const fetchDbTenants = await readAllTenant();
    
    if(fetchDbTenants) setTenantsDb(fetchDbTenants)
  };

  useEffect(() => {
    let cancel = false;
    
    if (cancel) return;
    getDataInitialPage();

    return () => {
      cancel = true
    };
  }, []);

  const handleFileChange = (e) => {
      setFile(e.target.files[0]);
      setNameFile(event.target.files[0].name);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

  if (!file || !name.trim() || !type.trim() || tenant.trim().length !== 3) {
    setMessage("Todos os campos são obrigatórios e tenant deve ter 3 caracteres.");
    return;
  }

  const formData = new FormData();
  formData.append("audioFile", file);
  formData.append("name", name.trim());
  formData.append("type", type.trim());
  formData.append("tenant", tenant.trim());

  setLoading(true);
  
  try {
      const response = await fetch(`http://${url}/api/uploads`, {
          method: "POST",
          body: formData,
      });

      const data = await response.json();
      if (response.ok) {
          toggleIsHidden('#upload-sended-info')
          setMessage(`Upload realizado com sucesso!`);
      } else {
          setMessage(`Erro: ${data.message}`);
      }
  } catch (error) {
      setMessage("Erro ao conectar com a API.");
  }

  setLoading(false);
};

return (
  <div>
    <div className="columns">
      <div className="column is-half is-offset-one-quarter has-text-centered">
        <strong className="is-size-3">UPLOAD - ARQUIVOS DE ÁUDIO</strong>
        <hr className="dropdown-divider"/>
      </div>
    </div>
    <form name="upload-form" id="upload-form" onSubmit={ handleSubmit }>
      <div className="columns mx-2">
        <label className="label column is-3 is-offset-1 field">Arquivo de áudio
          <div className="file is-primary">
            <label className="file-label">
              <input className="file-input" type="file" name="resume" accept="audio/*" onChange={handleFileChange}/>
              <span className="file-cta">
                <span className="file-icon">
                  <i className="fas fa-upload"></i>
                </span>
                <span className="file-label pr-4"> Selecionar arquivo </span>
              </span>
              <span className="file-name is-3 pr-6"> { nameFile ? nameFile : 'Nome do arquivo...'} </span>
            </label>
          </div>
        </label>
        <div className="field column is-2">
          <label className="label">Nome de Armazenamento
            <div className="control">
            <input className="input" name="name" type="text" onChange={(e) => setName(e.target.value)} placeholder="Apenas texto" />
            <p name="name-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
          </div>
          </label>
        </div>
        <div className="column is-2 field">
          <label className="label">Tipo de Áudio
            <div className="control">
              <div name="type" className="select is-fullwidth">
                <select className="select" name="type" onChange={(e) => setType(e.target.value)} >
                  <option value="">Selecione</option>
                  <option value="ura">URA</option>
                  <option value="moh">Música de Espera</option>
                </select>
              </div>
            </div>
          </label>
        </div>
        <div className="column is-2 field">
          <label className="label"> Cliente
            <div className="control">
              <div name="tenant" className="select is-fullwidth">
                <select className="select" name="tenant" onChange={(e) => setTenant(e.target.value)} >
                  <option value="">Selecione</option>
                  { 
                    tenantsDb ?
                      tenantsDb.map((tenant) => {
                      return (<option key={ tenant.short_name } value={ tenant.short_name }>{ tenant.name } - { tenant.short_name }</option>)
                      })
                    :
                    ''
                  }
                </select>
              </div>
            </div>
          </label>
        </div>
        <div className="column is-2 mt-1 field">
          <div className="field column is-1 has-text-centered">
            <div className="control">
              <button className="button is-info mt-3 is-small" type="submit" disabled={loading}>
                <span className="icon">
                  <FontAwesomeIcon icon={ faPen } fixedWidth />
                </span>
                <span>
                {loading ? "Enviando..." : "Enviar"}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <article id="upload-sended-info" name="upload-sended-info" className="column is-half is-offset-one-quarter message is-info is-hidden">
      <div className="message-header">
        <p>Informação!</p>
        <button className="info" aria-label="info" onClick={ () => toggleIsHidden('#upload-sended-info') }></button>
      </div>
      <div className="message-body">
        { message }
      </div>
    </article>
  </div>
  );
}
